import { injectScript, loadOnlyApp } from './browserApp';

// tawk.to's free live chat: the property and widget ids name the script, as tawk.to's own snippet does.
// https://help.tawk.to/article/adding-a-widget-to-your-website

type TawkWindow = Window & { Tawk_API?: Record<string, unknown>; Tawk_LoadStart?: Date };

// Loads tawk.to's widget for the property, once.
const install = (settings: Record<string, string | boolean>): void => {
  const propertyId = String(settings.propertyId || '');
  const widgetId = String(settings.widgetId || 'default');
  if (!/^[0-9a-f]{24}$/.test(propertyId) || !/^[A-Za-z0-9]{1,20}$/.test(widgetId)) return;
  const target = window as TawkWindow;
  target.Tawk_API ??= {};
  target.Tawk_LoadStart = new Date();
  injectScript('xshop-tawk', `https://embed.tawk.to/${propertyId}/${widgetId}`, { charset: 'UTF-8', crossorigin: '*' });
};

export const tawkApp = loadOnlyApp(install);
